// extracted by mini-css-extract-plugin
export default {"container":"Account_container__xga-l","label":"Account_label__g2EVq","error":"Account_error__EC4Rr","errorText":"Account_errorText__luOSd"};